import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/cn';

export const Spinner = ({ className }: { className?: string }) => <Loader2 aria-hidden className={cn('size-4 animate-spin text-current', className)} />;

/** Centered spinner for a page or panel that is loading. */
export const LoadingBlock = ({ label = 'Loading…', className }: { label?: string; className?: string }) => (
  <div role="status" className={cn('flex items-center justify-center gap-2 py-16 text-sm text-muted', className)}>
    <Spinner />
    {label}
  </div>
);

export const Skeleton = ({ className }: { className?: string }) => <div className={cn('animate-pulse rounded-md bg-surface-hover', className)} />;
